let backendUrl: string = 'https://bepetiz.com';

export const backend_url = backendUrl;